import React, { FC } from "react";
import { mergeStyleSets } from "@fluentui/react";

type Props = {
  value: number;
  label: string;
  secondaryText?: string;
};
const classes = mergeStyleSets({
  container: {
    // width: "215px",
    width: "calc(100% - 20px)",
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"flex-end",
  },
  labelContainer: {
    position: "relative"
  },
  progressContainer: {
    height: 10,
    width: "100%",
    backgroundColor: "#E2E6E8",
    borderRadius: 5
  },
  fillerStyles: {
    height: "100%",
    backgroundColor: "#4CAF50",
    borderRadius: "inherit",
    textAlign: "right"
  },
  label: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "13px",
    lineHeight: "20px",
    letterSpacing: "0.0025em",
    color: "#4C4C4C"
  },
  rightLabel: {
    textAlign: "right",
    fontSize: "13px",
    lineHeight: "20px",
    letterSpacing: "0.0025em",
    color: "#4C4C4C",
    position: "absolute",
    right: "0",
    bottom: "-10"
  }
});

const ProgressIndicator: FC<Props> = (props: Props) => {
  return (
    <div className={classes.container} style={{gap:12}}>
      <div className={classes.labelContainer}>
        <span className={classes.label}>{props.label}</span>
        {/* {props.secondaryText && (
          <span className={classes.rightLabel}>{props.secondaryText}</span>
        )} */}
      </div>
      <div className={classes.progressContainer}>
        <div
          className={classes.fillerStyles}
          style={{ width: `${props.value}%` }}
        ></div>
      </div>
      {props.secondaryText && (
        <span className={classes.rightLabel}>{props.secondaryText}</span>
      )}
    </div>
  );
};

export default ProgressIndicator;
